// const state = {
//     form: {
//         contract_data: {
//             contract_number: '',
//             volume: undefined,
//             cultivation_id: '',
//             safra: '',
//             warehouse_id: '',
//             delivery_location_id: '',
//             client_id: '',
//             contract_date: '',
//             delivery_date: ''
//         },
//         protocol_id: undefined,
//         properties: []
//     },
//     report: {
//         contract_number: '',
//         volume: undefined,
//         cultivation_id: '',
//         safra: '',
//         warehouse_id: '',
//         delivery_location_id: '',
//         client_id: '',
//         contract_date: '',
//         delivery_date: '',
//         properties: []
//     },
//     reportList: [],
//     summary: {
//         contracts_total: 0,
//         volume_total: 0,
//         properties_total: 0,
//         contracts_reproved_total: 0,
//         totalWaitingContracts: 0
//     },
//     filter: {
//         page: 0,
//         size: 10,
//         contract_number: '',
//         status: [],
//         loading: false
//     }
// };

// export default state;

const state = {
    id: null,
    typeList: [],
    silos: {},
    products: {},
    filter: {
        page: 0,
        size: 10,
        contract_number: '',
        status: [],
        initialDate: null,
        endDate: null,
        origin: 0,
        destination: 0,
        type: 4
    },
    operationList: {
        itens: [],
        page: 1,
        size: 10,
        totalElements: 0,
        totalPages: 0
    },
    individualExport: {
        idPortoOrigem: null,
        portoDestino: null,
        contraparte: null,
        codigoProduto: null,
        idSafra: null,
        volumeTon: null,
        descricao: null,
        numeroBl: null,
        dataBl: null,
        numeroAprovacao: null
    }
};

export default state;
